"use client";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "next-themes";

/**
 * Theme toggle (sun/moon). Shell-agnostic: caller passes `className` to match
 * the surrounding header's icon-button style. Icons are size 18 to align with
 * sibling lucide icons (SoundToggle, Search).
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { setTheme, theme } = useTheme();
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className={className}
      aria-label="Ganti tema (terang/gelap)"
    >
      <Sun
        size={18}
        className="scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90"
      />
      <Moon
        size={18}
        className="absolute scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0"
      />
      <span className="sr-only">Ganti tema</span>
    </Button>
  );
}
